'use client';

// imports
import { useRef, useState } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import UploadCard from './components/UploadCard';
import UploadTips from './components/UploadTips';
import { useInView } from '@/hooks/useInView';
import { ScanHeart } from 'lucide-react';

// constants
const base = 'transition-all duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]';
const hidden = 'opacity-0 translate-y-8';
const show = 'opacity-100 translate-y-0';

// component
export default function UploadPage() {

  // refs and state
  const tipsRef = useRef<HTMLDivElement | null>(null);
  const [highlightTips, setHighlightTips] = useState(false);

  // hooks
  const { ref: headerRef, isVisible: headerVisible } = useInView<HTMLDivElement>({
    threshold: 0.2,
    once: true,
  });

  const { ref: contentRef, isVisible: contentVisible } = useInView<HTMLDivElement>({
    threshold: 0.2,
    once: true,
  });

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-50/50 via-slate-50 to-cyan-50/30">
      <Navbar />
      <main className="flex-1 py-12 lg:py-16">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 xl:px-16">
          
          {/* page header */}
          <div ref={headerRef} className="text-center mb-10">
            <div className={`${base} ${headerVisible ? show : hidden} inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-600 rounded-full px-4 py-1.5 text-xs font-semibold mb-4`}>
              <ScanHeart className="w-3.5 h-3.5 text-blue-500" />
              Let's Get Started
            </div>
            <h1 className={`${base} delay-100 ${headerVisible ? show : hidden} text-3xl md:text-4xl font-bold text-slate-900 mb-3`}>
              Upload Your{' '}
              <span className="bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
                Tongue Image
              </span>
            </h1>
            <p className={`${base} delay-200 ${headerVisible ? show : hidden} text-slate-500 text-base max-w-lg mx-auto leading-relaxed`}>
              Take a clear photo of your tongue in good lighting, then upload it below for AI analysis.
            </p>
          </div>

          {/* main layout*/}
          <div className="flex flex-col lg:flex-row gap-8 items-stretch justify-center">
            <UploadCard
              tipsRef={tipsRef}
              setHighlightTips={setHighlightTips}
            />
            <UploadTips
              tipsRef={tipsRef}
              highlightTips={highlightTips}
            />
          </div>
          
        </div>
      </main>
      <Footer />
    </div>
  );
}